import * as React from 'react';
import { ArticleHeading4, RadioButtonGroup } from '@cian/ui-kit';
import classNames from 'classnames';

import { useDeviceCondition } from '../../../../hooks';

import { MoneySourceOptions } from './constants';
import * as styles from './MoneySource.css';

interface IProps {
  value: string;
  handleChange(v: string): void;
}

export const MoneySource = ({ value, handleChange }: IProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={styles['wrapper']}>
      <div className={styles['label']}>
        <ArticleHeading4>Счёт размещения</ArticleHeading4>
      </div>

      <div className={classNames(styles['buttons'], rootStyle)}>
        <RadioButtonGroup
          value={value}
          options={MoneySourceOptions}
          onChange={(e, value) => handleChange(value as string)}
        />
      </div>
    </div>
  );
};
